import { FormInput } from "../../../helpers/AdminHelper";
import { memo } from "react";

const VideoSection = ({ project, updateProject, inputClass }) => {
  const buttonClass = "bg-blue-600 px-2 py-1 rounded";
  const videos = project.videos || [];

  const addVideo = () => {
    updateProject("videos", [
      ...videos,
      {
        url: "",
        caption: "",
      },
    ]);
  };

  const handleChange = (index, field, value) => {
    const updatedVideo = [...videos];
    updatedVideo[index][field] = value;
    updateProject("videos", updatedVideo);
  };

  const removeVideoURL = (index) => {
    updateProject(
      "videos",
      videos.filter((_, i) => i !== index),
    );
  };
  console.log(project);
  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center">
        <h2 className="text-sm text-slate-300">Project Youtube Video</h2>

        <button type="button" onClick={addVideo} className={buttonClass}>
          + Add Video
        </button>
      </div>
      {videos.map((item, index) => (
        <div
          key={index}
          className="p-5 rounded-xl border border-white/10 bg-white/5 space-y-4"
        >
          <FormInput
            label={`Url ${index + 1}`}
            placeholder="www.youtube.com"
            className={inputClass}
            value={item.url}
            onChange={(e) => handleChange(index, "url", e.target.value)}
          />
          <FormInput
            label={`Caption ${index + 1}`}
            placeholder="Write the video caption"
            className={inputClass}
            value={item.caption}
            onChange={(e) => handleChange(index, "caption", e.target.value)}
          />
          <button
            type="button"
            onClick={() => removeVideoURL(index)}
            className="px-4 py-2 rounded-lg bg-red-600 hover:bg-red-700"
          >
            Remove Video
          </button>
        </div>
      ))}
    </div>
  );
};

export default memo(VideoSection);
